<template>
    <div class="tw-w-full tw-flex tw-flex-col">
        <div v-if="!fullyLoaded ">
            <div class="spinner-container tw-pt-10">
                <div class="spinner medium">
                    <div class="spinner-wrapper">
                        <div class="rotator">
                            <div class="inner-spin"></div>
                            <div class="inner-spin"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-else-if="content_error || catalog_error">
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10">
                <h1 class="tw-text-2xl tw-text-gray-700 tw-font-bold tw-mb-5">
                    Course could not be loaded
                </h1>
                <p class="tw-text-gray-600 tw-text-center tw-mb-5">
                    There seems to be a problem with the course. Please try again later.
                </p>
                <div @click="fetchData" class="general-button btn-v2 slim tw-font-bold tw-mt-4">
                    Try again
                </div>
            </div>
        </template>
        <template v-else>
            <course-hero :course="course" :modules="modules" :author="author" :menu="menu"
                         :extended="true"></course-hero>
            <div class="tw-bg-white tw-flex-1">
				<div
					 class="flex-parent-center tw-flex tw-flex-col tw-mb-5 md:tw-mb-0"
					 :class="course.module_theme + '-module-theme'">
					<div class="modules-wrapper tw-mt-10 tw-w-full tw-mb-20 md:tw-mb-10" v-if="menu === 'modules'">
						<module class="module tw-relative tw-overflow-hidden" v-for="(module, index) in modules"
								:module="module" :course="course" :index="index" :key="module.id"
								:modulesLength="modules.length"></module>
					</div>
				</div>
                <author :author="author" :courseId="course.id" v-if="author && menu === 'author'"></author>
                <div class="flex-parent-center tw-bg-white tw-py-10 tw-flex tw-flex-col"
                     v-else-if="menu === 'attachments'">
                    <h3 class="tw-text-xl tw-text-gray-700 tw-font-bold tw-mb-7">{{
                            $t('membership.attachments') }} {{ course.title ? course.title : course.name }}</h3>
                    <a :href="attachment.url ? attachment.url : '/uploads/membership/' + attachment.filename"
                       v-for="attachment in course.attachments"
                       v-if="attachment.type === 'lesson-files'" target="_blank"
                       class="file tw-flex tw-items-center tw-mb-4 tw-p-4 tw-rounded tw-simple-hover">
                        <i class="far fa-paperclip tw-text-gray-300"></i>
                        <p class="tw-flex-1 tw-ml-3 tw-text-gray-600">
                            {{ attachment.title }}
                        </p>
                    </a>
                </div>
            </div>

            <course-status-message :course="course" custom_class="tw-opacity-75 tw-bottom-16 tw-right-0"></course-status-message>
        </template>
    </div>
</template>

<script>
import Module from '../../components/e-learning/Module.vue';
import CourseHero from '../../components/e-learning/CourseHero.vue';
import Author from '../../components/e-learning/Author.vue';
import CourseStatusMessage from '../../components/e-learning/CourseStatusMessage.vue';
import Global from '../../mixins/Global.js';

export default {
    name: 'CoursesShow',

    mixins: [Global],

    components: {
        CourseStatusMessage,
        Module,
        CourseHero,
        Author
    },

    data() {
        return {
            menu: 'modules',
			content_loaded: false,
            content_error: false,
            catalog_loaded: false,
            catalog_error: false,
            catalog: [],
        }
    },

    computed: {
        course() {
            return CourseV2.query().where('slug', this.$route.params.course_slug).first();
        },

        modules() {
            return this.catalog.modules;
        },

        author() {
            if (this.course.author !== false) {
                return this.course.author;
            }

            return false;
        },

		fullyLoaded() {
			return this.content_loaded && this.catalog_loaded;
		},
    },

    methods: {
        setMenu(name) {
            this.menu = name;
        },

        fetchData() {
            this.content_loaded = false;
            this.catalog_loaded = false;

            CourseV2.api().fetchBySlug(this.$route.params.course_slug).then(() => {
                document.title = this.course.name;
                this.content_loaded = true;
                this.content_error = false;
            }).catch(() => {
                this.content_error = true;
            });

            CourseCatalogV4.api().fetchCourseCatalog(this.$route.params.course_slug).then((response) => {
                this.catalog_loaded = true;
                this.catalog_error = false;
                this.catalog = response.response.data.data;
            }).catch(() => {
                this.catalog_error = true;
            });
        },
    },

	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (!vm.content_loaded || !vm.catalog_loaded) {
				vm.fetchData();
			} else {
				document.title = vm.course.name;
			}
		});
	},

    // We use this function in the case a user navigates from the author module,
    // because we navigate from resources/:slug to resources/:slug,
    // beforeRouteEnter doesn't get called and we didn't fetch a course.
    beforeRouteUpdate(to, from, next) {
        this.fetchData();
        next();
    }
};
</script>

<style lang="scss" scoped>
.flex-parent-center {
    max-width: 900px;
    padding-left: 15px;
    padding-right: 15px;

    &.cards-module-theme {
        max-width: 1170px;

        .modules-wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-column-gap: 1rem;
            grid-row-gap: 1rem;

            @media(max-width: 1170px) {
                grid-template-columns: 1fr 1fr;
            }

            @media(max-width: 767px) {
                grid-template-columns: 1fr;
            }

            .module {
                @apply tw-rounded-lg tw-bg-gray-0;
            }
        }
    }
}
</style>
